// Mapeia o slug de ícone vindo da API (/painel.json → list_tools_shortcuts)
// para o ícone lucide correspondente do novo menu de ferramentas.
// O dashboard continua usando os SVGs de services/featureIcon.ts.
const TOOL_ICON_BY_SLUG: Record<string, string> = {
  bulletins: 'calendar-days',
  search: 'file-search',
  assignment: 'eye',
  assessment: 'target',
  star: 'folder-kanban',
  folder: 'files',
  robot: 'bot',
  chat: 'message-square-dot',
  digital_signature: 'pen-line',
  contact_support: 'clipboard-list',
  work: 'briefcase',
  gavel: 'file-pen',
  help_outline: 'message-circle-question',
  settings: 'activity',
  article: 'book-open',
  group: 'book-open',
  code: 'code-xml',
  school: 'graduation-cap',
  local_police: 'shield',
  receipt: 'receipt-text',
  bar_chart: 'trending-up',
  history: 'history',
  concurrent: 'users',
  manage_portals: 'layout-grid',
  dr_licita: 'sparkles',
  conlicitaseg: 'conlicitaseg',
  ia: 'message-square-text',
  resumo_edital: 'file-text',
  pergunte_ao_edital: 'message-circle-question',
  analyze_contract: 'file-warning',
  central_ia: 'sparkles',
  conlicitacao_academy: 'graduation-cap',
};

// Contratos e Jurídico Fácil compartilham o slug 'gavel' no banco de prod,
// mas o design aprovado dá um ícone a cada um — desempate por nome.
const TOOL_ICON_BY_NAME: Record<string, string> = {
  'Jurídico Fácil': 'gavel',
};

export const toolIconName = (slug: string, name?: string): string =>
  (name && TOOL_ICON_BY_NAME[name]) || TOOL_ICON_BY_SLUG[slug] || 'layout-grid';

export default toolIconName;
